module.exports = __webpack_public_path__ + "img/INF3105-ArbreAVL.7c350b38.png";